export default __webpack_public_path__ + "static/media/profile1.2fdc06bd.jpg";